<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormTimbradoHistorial" role="form" method="post" autocomplete="off" onSubmit="return false">					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="FechaInicio">Fecha Inicio</label>
							<div class="calendar">
								<Datepicker @input="CalculaFechaFinal" v-model="objTimbradoHistorial.FechaInicio" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
							</div>
							<CValidation v-if="this.errorvalidacion.FechaInicio" :Mensaje="'*'+errorvalidacion.FechaInicio[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="FechaVencimiento">Fecha Vencimiento</label>
							<div class="calendar">
								<input type="text" v-model="objTimbradoHistorial.FechaVencimiento" class="form-control" id="FechaVencimiento" placeholder="Ingresar Fecha Vencimiento" readonly />
							</div>
							<CValidation v-if="this.errorvalidacion.FechaVencimiento" :Mensaje="'*'+errorvalidacion.FechaVencimiento[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TimbresColocados">Timbres Colocados</label>
							<input type="text" v-model="objTimbradoHistorial.TimbresColocados" @input="$onlyNums($event,objTimbradoHistorial,'TimbresColocados')" class="form-control" id="TimbresColocados" placeholder="Ingresar Timbres Colocados" />
							<CValidation v-if="this.errorvalidacion.TimbresColocados" :Mensaje="'*'+errorvalidacion.TimbresColocados[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TimbresRestantes">Timbres Restantes</label>
							<input type="text" v-model="objTimbradoHistorial.TimbresRestantes" class="form-control" id="TimbresRestantes" placeholder="Ingresar Timbres Restantes" readonly />
							<CValidation v-if="this.errorvalidacion.TimbresRestantes" :Mensaje="'*'+errorvalidacion.TimbresRestantes[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Estatus">Estatus</label>
							<select v-model="objTimbradoHistorial.Estatus" class="form-control form-select" id="Estatus">
								<option value="">Seleccione una opción</option>
								<option value="Activo">Activo</option>
								<option value="Vencido">Vencido</option>
								<option value="Agotado">Agotado</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Estatus" :Mensaje="'*'+errorvalidacion.Estatus[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

export default {
    name: 'FormTimbradoHistorial',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTimbradoHistorial: {
				IdHistorialTimbres: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				FechaRegistro: '',
				FechaInicio: '',
				FechaVencimiento: '',
				TimbresColocados: '',
				TimbresRestantes: '',
				Estatus: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			Setpicker: Calendar.calendarSettings,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			let FechaInicio = '';

			if(this.objTimbradoHistorial.FechaInicio != '' && this.objTimbradoHistorial.FechaInicio != null){
				FechaInicio = moment(this.objTimbradoHistorial.FechaInicio).format('YYYY-MM-DD');
			}

			this.objTimbradoHistorial.FechaInicio = FechaInicio;

			if(this.objTimbradoHistorial.IdHistorialTimbres == 0) {
				await this.$http.post(
					'timbradoHistorial',this.objTimbradoHistorial
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'timbradoHistorial/'+this.objTimbradoHistorial.IdHistorialTimbres,
					this.objTimbradoHistorial
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "timbradoHistorial/"+this.objTimbradoHistorial.IdHistorialTimbres
            ).then((res) => {
                this.objTimbradoHistorial = res.data.data;

				// en caso de que necesite fecha
				let formatedDate1 = this.objTimbradoHistorial.FechaInicio.replace(/-/g,'\/');
                this.objTimbradoHistorial.FechaInicio = new Date(formatedDate1);
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objTimbradoHistorial = {
				IdHistorialTimbres: 0,
				IdEmpresa: 0,
				IdSucursal: 0,
				FechaRegistro: '',
				FechaInicio: '',
				FechaVencimiento: '',
				TimbresColocados: '',
				TimbresRestantes: '',
				Estatus: '',
				
            }
            this.errorvalidacion = [];
        },
		CalculaFechaFinal()
		{
			if(this.objTimbradoHistorial.FechaInicio != '')
			{
				let FechaFormat = moment(this.objTimbradoHistorial.FechaInicio).format('YYYY-MM-DD');
				let FechaFinal = moment(FechaFormat).add('1','year').format('YYYY-MM-DD');

				this.objTimbradoHistorial.FechaVencimiento = FechaFinal;
			}
			else{
				this.objTimbradoHistorial.FechaVencimiento = '';
			}
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			let ObjSucursal = JSON.parse(sessionStorage.getItem('objSucursal'));
			this.objTimbradoHistorial.IdEmpresa = ObjSucursal.IdEmpresa;
			this.objTimbradoHistorial.IdSucursal = ObjSucursal.IdSucursal;
                
            if (Id!='') 
            {
                this.objTimbradoHistorial.IdHistorialTimbres = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
